import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { DriverFormValues } from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

const TrunkCapacityBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<DriverFormValues>();

  return (
    <div className={styles.driverForm__block}>
      <h4 className={styles.driverForm__block__title}>{t("Trunk Capacity")}</h4>

      <div className={styles.driverForm__trunkCapacity}>
        <Controller
          control={control}
          name={"totalCargoWeight"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              label={t("Weight (kg)")}
              errorMessage={error?.message}
              maxLength={150}
              type="number"
            />
          )}
        />

        <Controller
          control={control}
          name={"totalCargoVolume"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value || ""}
              onChange={onChange}
              label={t("Volume (cbm)")}
              errorMessage={error?.message}
              maxLength={150}
              type="number"
            />
          )}
        />
      </div>
    </div>
  );
};

export default TrunkCapacityBlock;
